'use strict';

exports.__esModule = true;

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

exports.default = createRouteDispatchers;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _history = require('history');

var _hoistNonReactStatics = require('hoist-non-react-statics');

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _reactDisplayName = require('react-display-name');

var _reactDisplayName2 = _interopRequireDefault(_reactDisplayName);

var _invariant = require('invariant');

var _invariant2 = _interopRequireDefault(_invariant);

var _warning = require('warning');

var _warning2 = _interopRequireDefault(_warning);

var _RouteDispatcher = require('./RouteDispatcher');

var _RouteDispatcher2 = _interopRequireDefault(_RouteDispatcher);

var _dispatchRouteActions = require('./dispatchRouteActions');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __DEV__ = process.env.NODE_ENV !== 'production';

function RouteDispatcherHoc(displayNamePrefix, routeConfig, options) {
    var routerDispatcher = function routerDispatcher(_ref) {
        var routes = _ref.routes,
            props = (0, _objectWithoutProperties3.default)(_ref, ['routes']);

        return _react2.default.createElement(_RouteDispatcher2.default, (0, _extends3.default)({
            routes: routes || routeConfig
        }, options, props));
    };

    routerDispatcher.displayName = displayNamePrefix + '(' + (0, _reactDisplayName2.default)(_RouteDispatcher2.default) + ')';

    return (0, _hoistNonReactStatics2.default)(routerDispatcher, _RouteDispatcher2.default);
}

function mergeActions(flatActions, actionNames) {
    return flatActions.reduce(function (actions, actionName) {
        if (actions.indexOf(actionName) === -1) {
            actions.push(actionName);
        }

        return actions;
    }, actionNames);
}

function getActionNames(actions) {
    return actions.map(function (action) {
        if (Array.isArray(action)) {
            return getActionNames(action);
        }

        if (typeof action.name === 'string') {
            return action.name;
        }

        (0, _invariant2.default)(false, 'invalid dispatcher action \'name\', expected string but encountered ' + action.name);
    });
}

function findRouteActions(routes, routeComponentPropNames) {
    var actionNames = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

    routes.forEach(function (route) {
        (0, _dispatchRouteActions.getRouteComponents)(route, routeComponentPropNames).forEach(function (_ref2) {
            var routeComponent = _ref2.routeComponent;

            if (typeof routeComponent.getDispatcherActions === 'function') {
                mergeActions(getActionNames(routeComponent.getDispatcherActions()), actionNames);
            }
        });

        if (Array.isArray(route.routes)) {
            findRouteActions(route.routes, routeComponentPropNames, actionNames);
        }
    });

    return actionNames;
}

function flattenActions(actions) {
    if (!Array.isArray(actions)) {
        return [actions];
    }

    return actions.reduce(function (flatActions, action) {
        if (Array.isArray(action)) {
            Array.prototype.push.apply(flatActions, flattenActions(action));
        } else {
            flatActions.push(action);
        }

        return flatActions;
    }, []);
}

function createDispatchAction(dispatchFuncName, pathAndQuery, params, options) {
    (0, _invariant2.default)(typeof pathAndQuery === 'string', 'pathAnyQuery expects a string');

    var actionNames = options.actionNames,
        routes = options.routes,
        routeComponentPropNames = options.routeComponentPropNames;

    return _RouteDispatcher2.default[dispatchFuncName]((0, _history.parsePath)(pathAndQuery), actionNames, { routes: routes, routeComponentPropNames: routeComponentPropNames }, (0, _assign2.default)({}, params));
}

// use a factory method to simplify server usage
function createRouteDispatchers(routeConfig, actionNames) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    (0, _invariant2.default)(Array.isArray(routeConfig), 'routeConfig expects an array of routes');

    var dispatchOpts = (0, _assign2.default)({ routeComponentPropNames: _RouteDispatcher.DEFAULT_COMPONENT_PROP_NAMES }, options, { actionNames: actionNames, routes: routeConfig });

    var routes = dispatchOpts.routes,
        componentOptions = (0, _objectWithoutProperties3.default)(dispatchOpts, ['routes']);

    // If no actions are configured, determine actions from component configuration

    if (typeof dispatchOpts.actionNames === 'undefined' || dispatchOpts.actionNames === null) {
        dispatchOpts.actionNames = findRouteActions(routes, dispatchOpts.routeComponentPropNames);
    } else if (__DEV__) {
        var configuredActionNames = flattenActions(dispatchOpts.actionNames);
        var routeActionNames = findRouteActions(routes, dispatchOpts.routeComponentPropNames);

        var unconfiguredActions = routeActionNames.filter(function (actionName) {
            return configuredActionNames.indexOf(actionName) === -1;
        });
        var unusedActions = configuredActionNames.filter(function (actionName) {
            return routeActionNames.indexOf(actionName) === -1;
        });
        (0, _warning2.default)(unconfiguredActions.length === 0, 'The actions \'' + unconfiguredActions.join(', ') + '\' are used by route components, but are not configured for use by the route dispatcher.');
        (0, _warning2.default)(unusedActions.length === 0, 'The actions \'' + unusedActions.join(', ') + '\' are configured for use with the route dispatcher, but no route components have the action(s) applied.');
    }

    return {

        /**
         * The configured action name(s). Useful for debugging purposes.
         */
        actionNames: dispatchOpts.actionNames.slice(),

        /**
         * dispatch route actions on the server.
         *
         * @param pathAndQuery string the requested url path and query
         * @param params Object params for actions
         * @param options [Object] options for server dispatching
         * @returns {*} Components for rendering routes
         */
        dispatchServerActions: function dispatchServerActions(pathAndQuery) {
            var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
            return createDispatchAction('dispatchServerActions', pathAndQuery, params, (0, _extends3.default)({}, dispatchOpts, options));
        },

        /**
         * Synchronous client dispatcher
         *
         * @param pathAndQuery
         * @param params
         * @param options
         */
        dispatchClientActions: function dispatchClientActions(pathAndQuery) {
            var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
            var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
            return createDispatchAction('dispatchClientActions', pathAndQuery, params, (0, _extends3.default)({}, dispatchOpts, options));
        },

        ClientRouteDispatcher: RouteDispatcherHoc('ClientRouteDispatcher', routes, componentOptions),

        UniversalRouteDispatcher: RouteDispatcherHoc('UniversalRouteDispatcher', routes, (0, _extends3.default)({}, componentOptions, { dispatchActionsOnFirstRender: false }))
    };
}